import { TableBody as MuiTableBody, TableRow, TableCell } from '@mui/material';
import { orderedProperties } from './TableHead';
import { VerticalData } from '@features/benchmarks';

export type TableBodyProps = {
  data: readonly VerticalData[];
};

export const TableBody = (props: TableBodyProps) => {
  return (
    <MuiTableBody>
      {props.data.map(vertical => (
        <TableRow key={vertical.name}>
          {orderedProperties.map(property => (
            <TableCell key={property}>{vertical[property]}</TableCell>
          ))}
        </TableRow>
      ))}
    </MuiTableBody>
  );
};
